export enum ProjectSettingsSubmenuOptions {
    Customisation = "Customisation",
    ProjectRolePermissions = "Project role permissions",
    ScheduleConfig = "Schedule config",
    Attributes = "Project Attributes",
    Sitemaps = "Sitemaps",
    Billing = "Billing",
    Sso = "Sso Configuration",
}
